module.exports = __webpack_public_path__ + "img/VIMC Diamond3.222cf341.jpg";